<template>
  <div style="padding-bottom: 0.5rem">
    <label class="label">{{this.label}}</label>
    <b-field class="group">
      <b-radio-button class="full-width" :name="name" v-model="data" :native-value="optionA" v-on:input="update()" v-validate="validationRule">
        <slot name="option-a">Yes</slot>
      </b-radio-button>
      <b-radio-button class="full-width" :name="name" v-model="data" :native-value="optionB" v-on:input="update()" v-validate="validationRule">
        <slot name="option-b">No</slot>
      </b-radio-button>
    </b-field>
  </div>
</template>

<script>
export default {
  props: ['name', 'value', 'option-a', 'option-b', 'label', 'validation-rule'],
  inject: ['$validator'],
  data() {
    return {
      data: this.value
    }
  },
  methods: {
    update: function() {
      this.$emit('input', this.data)
    }
  }
}
</script>

<style scoped>
.full-width {
  width: 100%;
}
.group {
  display: flex;
}
</style>
<style>
.b-radio.radio.button {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/inputs/RvRadio.vue